"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tagsMapping = {
    'CWE-611': 'https://cwe.mitre.org/data/definitions/611.html',
    'CWE-77': 'https://cwe.mitre.org/data/definitions/77.html',
    'CWE-384': 'https://cwe.mitre.org/data/definitions/384.html',
    'CWE-330': 'https://cwe.mitre.org/data/definitions/330.html',
    'CWE-79': 'https://cwe.mitre.org/data/definitions/79.html',
    'CWE-22': 'https://cwe.mitre.org/data/definitions/22.html',
    'CWE-265': 'https://cwe.mitre.org/data/definitions/265.html',
    'CWE-489': 'https://cwe.mitre.org/data/definitions/489.html',
    'CWE-522': 'https://cwe.mitre.org/data/definitions/522.html',
    'CWE-613': 'https://cwe.mitre.org/data/definitions/613.html',
    'CWE-203': 'https://cwe.mitre.org/data/definitions/203.html',
    'CWE-352': 'https://cwe.mitre.org/data/definitions/352.html',
    'CWE-451': 'https://cwe.mitre.org/data/definitions/451.html',
    'CWE-601': 'https://cwe.mitre.org/data/definitions/601.html',
    'CWE-425': 'https://cwe.mitre.org/data/definitions/425.html',
    'CWE-779': 'https://cwe.mitre.org/data/definitions/779.html',
    'CWE-922': 'https://cwe.mitre.org/data/definitions/922.html',
    'CWE-89': 'https://cwe.mitre.org/data/definitions/89.html',
    'CWE-121': 'https://cwe.mitre.org/data/definitions/121.html',
    'CWE-193': 'https://cwe.mitre.org/data/definitions/193.html',
    'CWE-122': 'https://cwe.mitre.org/data/definitions/122.html',
    'CWE-190': 'https://cwe.mitre.org/data/definitions/190.html',
    'CWE-134': 'https://cwe.mitre.org/data/definitions/134.html',
    'CWE-244': 'https://cwe.mitre.org/data/definitions/244.html',
    'CWE-749': 'https://cwe.mitre.org/data/definitions/749.html',
    'CWE-733': 'https://cwe.mitre.org/data/definitions/733.html',
    'CWE-476': 'https://cwe.mitre.org/data/definitions/476.html',
    'CWE-362': 'https://cwe.mitre.org/data/definitions/362.html',
    'CWE-295': 'https://cwe.mitre.org/data/definitions/295.html',
    'CWE-502': 'https://cwe.mitre.org/data/definitions/502.html',
    'CWE-540': 'https://cwe.mitre.org/data/definitions/540.html',
    'CWE-1035': 'https://cwe.mitre.org/data/definitions/1035.html',
    'CWE-602': 'https://cwe.mitre.org/data/definitions/602.html',
    'CWE-830': 'https://cwe.mitre.org/data/definitions/830.html',
    'CWE-284': 'https://cwe.mitre.org/data/definitions/284.html',
    'CWE-285': 'https://cwe.mitre.org/data/definitions/285.html',
    'CWE-213': 'https://cwe.mitre.org/data/definitions/213.html',
    'CWE-307': 'https://cwe.mitre.org/data/definitions/307.html',
    'CWE-248': 'https://cwe.mitre.org/data/definitions/284.html',
    'CWE-1032': 'https://cwe.mitre.org/data/definitions/1032.html',
    'CWE-1028': 'https://cwe.mitre.org/data/definitions/1028.html',
    'CWE-434': 'https://cwe.mitre.org/data/definitions/434.html',
    'CWE-90': 'https://cwe.mitre.org/data/definitions/90.html',
    'CWE-256': 'https://cwe.mitre.org/data/definitions/256.html',
    'CWE-778': 'https://cwe.mitre.org/data/definitions/778.html',
    'CWE-113': 'https://cwe.mitre.org/data/definitions/113.html',
    'CWE-74': 'https://cwe.mitre.org/data/definitions/74.html',
    'A3: Injection': 'https://owasp.org/Top10/A03_2021-Injection/',
    'A5: Security Misconfiguration ': 'https://owasp.org/Top10/A05_2021-Security_Misconfiguration/',
    'A7: Identification and Authentication Failures ': 'https://owasp.org/Top10/A07_2021-Identification_and_Authentication_Failures/',
    'A1: Broken Access Control ': 'https://owasp.org/Top10/A01_2021-Broken_Access_Control/',
    'A4: Insecure Design': 'https://owasp.org/Top10/A04_2021-Insecure_Design/',
    'A9: Security Logging and Monitoring Failures ': 'https://owasp.org/Top10/A09_2021-Security_Logging_and_Monitoring_Failures/',
    'is it "Sensitive Data in File Storage"?': 'https://www.owasp.org/index.php/Top_10-2017_A5-Broken_Access_Control',
    'is it "Insecure Local Storage"?': 'https://www.owasp.org/index.php/Top_10-2017_A5-Broken_Access_Control',
    'what is this lesson?': 'https://www.owasp.org/index.php/Top_10-2017_A5-Broken_Access_Control',
    'A6: Vulnerable and Outdated Components ': 'https://owasp.org/Top10/A06_2021-Vulnerable_and_Outdated_Components/',
    'A2: Cryptographic Failures': 'https://owasp.org/Top10/A02_2021-Cryptographic_Failures/',
    'A8: Software and Data Integrity Failures': 'https://owasp.org/Top10/A08_2021-Software_and_Data_Integrity_Failures/',
    'A10: Server-Side Request Forgery ': 'https://owasp.org/Top10/A10_2021-Server-Side_Request_Forgery_%28SSRF%29/',
    'A10:2021': 'https://owasp.org/Top10/A10_2021-Server-Side_Request_Forgery_%28SSRF%29/',
    'SANS-#1': 'http://cwe.mitre.org/top25/#CWE-89',
    'SANS-#4': 'http://cwe.mitre.org/top25/#CWE-79',
    'SANS-#13': 'http://cwe.mitre.org/top25/#CWE-22',
    'SANS-#12': 'http://cwe.mitre.org/top25/#CWE-352',
    'SANS-#22': 'http://cwe.mitre.org/top25/#CWE-601',
    'SANS-#15': 'http://cwe.mitre.org/top25/#CWE-863',
    'SANS-#3': 'http://cwe.mitre.org/top25/#CWE-120',
    'SANS-#20': 'http://cwe.mitre.org/top25/#CWE-131',
    'SANS-#24': 'http://cwe.mitre.org/top25/#CWE-190',
    'SANS-#23': 'http://cwe.mitre.org/top25/#CWE-134',
    'SANS-#16': 'http://cwe.mitre.org/top25/#CWE-829'
};
var getTags = function (lesson, cwekey, owaspKey, sansKey) {
    if (cwekey === void 0) { cwekey = 'cwe'; }
    if (owaspKey === void 0) { owaspKey = 'owasp'; }
    if (sansKey === void 0) { sansKey = 'sans'; }
    var tags = [];
    if (lesson[cwekey]) {
        tags.push({ tag: lesson[cwekey], url: tagsMapping[lesson[cwekey]] });
    }
    if (lesson[owaspKey]) {
        tags.push({ tag: lesson[owaspKey], url: tagsMapping[lesson[owaspKey]] });
    }
    if (lesson[sansKey]) {
        tags.push({ tag: lesson[sansKey], url: tagsMapping[lesson[sansKey]] });
    }
    return tags;
};
exports.default = getTags;
